export enum SnackBarType {
  SUCCESS = 'success',
  INFORMATION = 'information',
  ERROR = 'error'
}
